// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3Ji7H","title":"FrontImage_title__3XgIE"};